import * as React from 'react';

import styled, { tstyled } from './theme';
import Globals from './Globals';
import FixedGlobalLoader from './components/FixedGlobalLoader';
import App from './App';
import About from './models/About';
import Footer from './models/Footer';
import Project from './models/Project';
import ProjectType from './models/ProjectType';
import WhistleTrack from './models/WhistleTrack';

interface IState {
  loaded: boolean;
}

const LoaderContainer = tstyled<IState, HTMLDivElement>(styled.div)`
  opacity: ${props => (props.loaded ? 0 : 1)};
  transition: 0.01s ease-in-out opacity;
  display: ${props => (props.loaded ? 'none' : 'block')};
`;

const AppContainer = tstyled<IState, HTMLDivElement>(styled.div)`
  opacity: ${props => (props.loaded ? 1 : 0)};
  transition: 0.62s cubic-bezier(0.77, 0, 0.175, 1) ;
`;

class Loader extends React.PureComponent<{}, IState> {
  state: IState = {
    loaded: false,
  };

  componentDidMount() {
    this.loadEverything();
  }

  async loadEverything() {
    const promises: Array<Promise<any>> = [];

    const projectType = await ProjectType.getData();

    projectType.items.forEach(item => {
      item.fields.projects.forEach(project => {
        promises.push(Project.getData(project.fields.slug));
      });
    });

    promises.push(About.getData(), Footer.getData(), WhistleTrack.getData());

    promises.push(new Promise(resolve => setTimeout(resolve, 2500)));

    await Promise.all(promises);

    requestAnimationFrame(() => this.setState({ loaded: true }));
  }

  render() {
    return (
      <Globals>
        <LoaderContainer loaded={this.state.loaded}>
          <FixedGlobalLoader />
        </LoaderContainer>
        <AppContainer loaded={this.state.loaded}>
          {this.state.loaded && <App />}
        </AppContainer>
      </Globals>
    );
  }
}

export default Loader;



// WEBPACK FOOTER //
// ./src/Loader.tsx